import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "../componenets/MainSections/Header";
import Home from "../componenets/MainSections/Home";
import Footer from "../componenets/MainSections/Footer";
import EstimateModal from "../componenets/MainSections/EstimateModal";
import ServiceDetail from "../componenets/MainSections/ServiceDetail";
import LocalServicePage from "../componenets/LocalServicePage"; // ✅ Add this import

function App() {
  const [showEstimate, setShowEstimate] = useState(false);

  return (
    <Router>
      <Header onOpenEstimate={() => setShowEstimate(true)} />
      <Routes>
        <Route
          path="/"
          element={<Home onOpenEstimate={() => setShowEstimate(true)} />}
        />
        <Route
          path="/services/:slug"
          element={
            <ServiceDetail onOpenEstimate={() => setShowEstimate(true)} />
          }
        />

        {/* ✅ Local Service SEO Pages */}
        <Route
          path="/lawn-care-monroe-nj"
          element={<LocalServicePage town="Monroe" />}
        />
        <Route
          path="/lawn-care-east-windsor-nj"
          element={<LocalServicePage town="East Windsor" />}
        />
        <Route
          path="/lawn-care-plainsboro-nj"
          element={<LocalServicePage town="Plainsboro" />}
        />
        <Route
          path="/lawn-care-west-windsor-nj"
          element={<LocalServicePage town="West Windsor" />}
        />
        <Route
          path="/lawn-care-princeton-junction-nj"
          element={<LocalServicePage town="Princeton Junction" />}
        />
        <Route
          path="/lawn-care-dayton-nj"
          element={<LocalServicePage town="Dayton" />}
        />
        <Route
          path="/lawn-care-robbinsville-nj"
          element={<LocalServicePage town="Robbinsville" />}
        />
        <Route
          path="/lawn-care-cranbury-nj"
          element={<LocalServicePage town="Cranbury" />}
        />
      </Routes>

      <EstimateModal
        show={showEstimate}
        onClose={() => setShowEstimate(false)}
      />
      <Footer />
    </Router>
  );
}

export default App;
